import dayjs from 'dayjs';

export interface QuarterPeriod {
  year: number;
  // 1..4
  quarter: number;
}

export const quarterOfMonth = (month: number): number => Math.ceil(month / 3);

/**
 * Отчётный квартал.
 *
 * Квартальный отчёт сдают 25 числа ПОСЛЕДНЕГО месяца квартала — то есть внутри
 * него, не дожидаясь конца. Поэтому весь последний месяц отчётным считается
 * текущий квартал, а в остальное время — предыдущий завершённый.
 *
 * Эссе за этот последний месяц к моменту сдачи ещё не написано (месячные пишут
 * в начале следующего), так что в источниках он честно окажется пропущенным, а
 * человек дополнит отчёт руками.
 *
 * 15-дневная отсечка из `essayPeriod` сюда не переносится: у месяца и квартала
 * разные сроки сдачи, и общее правило дало бы неверный период обоим.
 *
 * `now` параметром, а не dayjs() внутри, чтобы границы года проверялись тестом,
 * а не подменой системного времени. Арифметика вместо
 * `now.subtract(1, 'quarter')`: единицу «квартал» dayjs понимает только с
 * плагином quarterOfYear, а без него молча ничего не вычитает.
 */
export const reportingQuarter = (now: dayjs.Dayjs = dayjs()): QuarterPeriod => {
  const month = now.month() + 1;
  const current = quarterOfMonth(month);
  // Последний месяц квартала — тот, в котором его и сдают.
  if (month % 3 === 0) return { year: now.year(), quarter: current };
  return current === 1
    ? { year: now.year() - 1, quarter: 4 }
    : { year: now.year(), quarter: current - 1 };
};

/** Соседний квартал: `step` в кварталах, ±1 для стрелок «назад» и «вперёд». */
export const shiftQuarter = (period: QuarterPeriod, step: number): QuarterPeriod => {
  const index = period.year * 4 + (period.quarter - 1) + step;
  return { year: Math.floor(index / 4), quarter: (index % 4) + 1 };
};

/** Раньше ли первый период второго. Для «дальше некуда» у стрелки вперёд. */
export const isBeforeQuarter = (a: QuarterPeriod, b: QuarterPeriod): boolean =>
  a.year * 4 + a.quarter < b.year * 4 + b.quarter;
